import { contactData } from '@/mocks/homeData';

export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
          {contactData.title}
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-2xl mx-auto">
          {contactData.desc}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 md:gap-10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
              <i className="ri-mail-line text-xl text-primary-600"></i>
            </div>
            <div className="text-left">
              <div className="text-xs text-foreground-400">电子邮箱</div>
              <div className="text-sm font-medium text-foreground-700">{contactData.email}</div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
              <i className="ri-time-line text-xl text-primary-600"></i>
            </div>
            <div className="text-left">
              <div className="text-xs text-foreground-400">工作时间</div>
              <div className="text-sm font-medium text-foreground-700">{contactData.hours}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}